var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.3335H14.25V0.333496H16.5C16.6989 0.333496 16.8897 0.403734 17.0303 0.528758C17.171 0.653782 17.25 0.823352 17.25 1.00016V7.66683C17.25 7.84364 17.171 8.01321 17.0303 8.13823C16.8897 8.26326 16.6989 8.3335 16.5 8.3335ZM12.5303 9.1955L7.73025 13.4622C7.66646 13.519 7.58171 13.5535 7.49159 13.5593C7.40147 13.565 7.31204 13.5417 7.23975 13.4935L6.6 13.0668C6.42233 12.9483 6.28812 12.7856 6.21431 12.5993C6.1405 12.4131 6.13039 12.2115 6.18525 12.0202L7.05 9.00016H2.25C1.85218 9.00016 1.47065 8.85969 1.18934 8.60964C0.908036 8.35959 0.750001 8.02045 0.750001 7.66683V6.26416C0.749799 6.08992 0.788019 5.91734 0.862501 5.75616L3.1845 0.746829C3.24096 0.624665 3.33697 0.52016 3.46035 0.446571C3.58373 0.372982 3.72892 0.333626 3.8775 0.333496H12C12.1989 0.333496 12.3897 0.403734 12.5303 0.528758C12.671 0.653782 12.75 0.823352 12.75 1.00016V8.72416C12.75 8.90096 12.6709 9.0705 12.5303 9.1955Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.35d026e7d6fa3e74ac4a3410209c9fe7.svg";
export { ForwardRef as ReactComponent };